import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '@/utilities/api/baseQuery';
import API_TAGS from './api-tag.enum';

const baseApiSlice = createApi({
  reducerPath: 'baseApi',
  baseQuery,
  tagTypes: Object.values(API_TAGS),
  endpoints: () => ({}),
});

export default baseApiSlice;
